export default "__VITE_ASSET__k27JWASw__"